import { post } from "../http/functions";

export const generateExportMutationFn = async ({ year, period, statuses, type, ...options }) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (period) params.append("period", period);
    const path = `/export?${params.toString()}`;
    const response = await post(
      path,
      {
        statuses: (statuses || "").split(","),
        formType: type
      },
      {
        ...options || {},
        headers: {
          'Accept': 'text/csv',
          ...options?.headers || {}
        },
        stringify: false
      },
    );
    
    let csvText;
    if (response?.text) {
      csvText = await response.text();
    } else if (response?.getReader) {
      csvText = await new Response(response).text();
    } else {
      throw new Error('Export failed');
    }

    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const fileName = `forms-year-${year}-period-${period}-${Date.now()}.csv`;
    
    return {
      data: { 
        downloadUrl: url, 
        fileName
      }
    };

  } catch (error) {
    return error?.error ? error : { error };
  }
};